module.exports = __webpack_public_path__ + "static/media/goal_flag_green.c2a48936.svg";